import {
  addAssessmentSets,
  addDestructuredSubtests,
  getActivity,
  getAnswersByItem,
  getScoring,
  getTimeRemaining,
  transformSets
} from "."

/**
 * Manages pulling data needed for uA from different
 * db collections.
 * @param {object} userAssessment the userAssessment data
 * @returns {object} fulfilled promise returns userAssessment
 * with extra data added
 */
export default function addExtraData(userAssessment) {
  if (!userAssessment) return {}
  let assessmentSet, assessmentSubtests
  return addAssessmentSets(userAssessment.assessmentSetId)
    .then(sets => {
      assessmentSet = sets.assessmentSet
      assessmentSubtests = sets.assessmentSubtests
      const destructured = addDestructuredSubtests({
        ...userAssessment,
        assessmentSet,
        assessmentSubtests
      })

      const activity = getActivity(userAssessment)
      const answersByItem = getAnswersByItem(userAssessment.userAssessmentId)
      const scoring = getScoring(
        userAssessment.userAssessmentId,
        userAssessment.userId
      )
      const timeRemaining = getTimeRemaining(userAssessment.userAssessmentId)
      return Promise.all([
        destructured,
        activity,
        answersByItem,
        scoring,
        timeRemaining
      ])
    })
    .then(results => {
      let [
        uA,
        activity,
        answersByItem,
        scoring,
        timeRemaining
        // destructured
      ] = results
      uA = transformSets(uA)
      return {
        ...uA,
        activity,
        answersByItem,
        scoring,
        timeRemaining
        // destructured
      }
    })
}
